import { useCallback, type ComponentProps } from 'react';

import PropertyCartTable from './PropertyCartTable';
import { useFreeFloorPlanOffer } from '../floor-plan/useFreeFloorPlanOffer';
import type { PropertyCartItem } from '../types/cart.types';

type AccountPropertyCartTableProps = Omit<
  ComponentProps<typeof PropertyCartTable>,
  'freeFloorPlanFor'
> & {
  /** The account these lines belong to. */
  entityUUID: string | undefined;
};

/**
 * One account's property lines in the cart, with the free floor plan each will
 * get (DV-3204). The offer is decided per account (DV-3697), and the cart
 * already groups its lines by account, so each group asks about its own.
 */
const AccountPropertyCartTable = ({
  entityUUID,
  ...tableProps
}: AccountPropertyCartTableProps) => {
  const { freeTierFor } = useFreeFloorPlanOffer({ entityUUID });
  const freeFloorPlanFor = useCallback(
    (item: PropertyCartItem) =>
      // A line from another account (or none) was not asked about.
      item.entityUUID === entityUUID
        ? freeTierFor((item.services ?? []).map((s) => s.shoppingCartSlug))
        : null,
    [freeTierFor, entityUUID]
  );

  return (
    <PropertyCartTable {...tableProps} freeFloorPlanFor={freeFloorPlanFor} />
  );
};

export default AccountPropertyCartTable;
